<template>
  <div class="banner-box">
    <!-- 暂时没有轮播图 先注视 -->
    <el-carousel v-if="false" indicator-position="outside" height="94px" :interval="5000">
      <el-carousel-item v-for="item in 4" :key="item" />
    </el-carousel>
    <div>
      <img src="../../images/banner.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.banner-box {
  border-radius: 8px;
}
</style>
